import i18n from 'scoreboard/components/i18n'

/**
 * Returns localized text like "Left Axis" or "Left and Right Axes" based on
 * which axes are currently used in the given chart.
 *
 * @param {ChartDesigner} chart
 */
function axesText (chart) {
	[leftCount, rightCount] = chart.features
		.partition(f => f.get('axis') === 'left')
		.map(axis => axis.length)

	let axesText = 'charts.chart.'
	if (leftCount && rightCount) {
		axesText += 'leftAndRightAxes'
	} else if (leftCount) {
		axesText += 'leftAxis'
	} else if (rightCount) {
		axesText += 'rightAxis'
	} else {
		axesText += 'leftAndRightAxes'
	}

	return i18n.get(axesText)
}

export default axesText

axesText.__filename__ = 'charts/edit/axes-text.js'
